import { createBrowserRouter, Navigate } from "react-router-dom";
import { useAuthContext } from "../hooks/useAuth";
import AreaOfInterests from "../screens/aoi";
import BusinessPage from "../screens/business";
import CouponsPage from "../screens/coupons";
import CsuiteUsers from "../screens/cSuite";
import Dashboard from "../screens/dashboard";
import LifestylePage from "../screens/lifestyle";
import Login from "../screens/login";
import PageNotFound from "../screens/page_not_found";
import PrivacyPolicy from "../screens/privacyPolicy";
import Users from "../screens/users";
import HandleUserAuth from "../screens/handleUserChanges";
import Announcements from "../screens/announcements";
import AnnouncementsDetails from "../screens/announementsDetails";
import Designations from "../screens/designation";
import ForgotPassword from "../screens/ForgotPassword";
import LifestyleDetail from "../screens/lifestyleDetail";
import BusinessDetail from "../screens/businessDetail";
import { Loader } from "../hooks/useLoading";
import ConnectionReasons from "../screens/connectionReasons";
import ConnectionResponse from "../screens/connectionResponse";
import EmailTemplate from "../screens/emailTemplate";
import EditEmailTemplate from "../screens/editEmailTemplate";

// function RequireAuth({ children }) {
//   const { authed } = useAuthContext();
//   // console.log({ authed });

//   return authed ? children : <Navigate to="/login" replace />;
// }

function RequireAuth({ children }) {
  const { authed, loading } = useAuthContext();

  if (loading) {
    return <Loader />
  }

  return authed ? children : <Navigate to="/login" replace />;
}

const router = createBrowserRouter([
  {
    path: "/",
    element: <Login />,
    errorElement: <PageNotFound />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "handle-user-auth",
    element: <HandleUserAuth />,
  },
  {
    path: "/connection-response",
    element: <ConnectionResponse />,
  },
  {
    path: "/dashboard",
    element: (
      <RequireAuth>
        <Dashboard />
      </RequireAuth>
    ),
    children: [
      {
        path: "business",
        element: <BusinessPage />,
      },
      {
        path: "business/:id",
        element: <BusinessDetail />,
      },
      {
        path: "lifestyle",
        element: <LifestylePage />,
      },
      {
        path: "lifestyle/:id",
        element: <LifestyleDetail />,
      },
      {
        path: "aoi",
        element: <AreaOfInterests />,
      },
      {
        path: "coupons",
        element: <CouponsPage />,
      },
      {
        path: "users",
        element: <Users />,
      },
      {
        path: "designation",
        element: <Designations />,
      },
      {
        path: "c-suite",
        element: <CsuiteUsers />,
      },
      {
        path: "announcements",
        element: <Announcements />,
      },
      {
        path: "announcements/:id",
        element: <AnnouncementsDetails />,
      },
      // {
      //   path: "users",
      //   element: <UsersPage />,
      // },
      {
        path: "connection-reasons",
        element: <ConnectionReasons />,
      },
      {
        path: "email-templates",
        element: <EmailTemplate />,
      },
      {
        path: "email-templates/:id",
        element: <EditEmailTemplate />,
      }
    ],
  },
  // {
  //   path: "/business",
  //   element: (
  //     <RequireAuth>
  //       <BusinessPage />
  //     </RequireAuth>
  //   ),
  // },
  // {
  //   path: "/lifestyle",
  //   element: (
  //     <RequireAuth>
  //       <LifestylePage />
  //     </RequireAuth>
  //   ),
  // },
  // {
  //   path: "/aoi",
  //   element: (
  //     <RequireAuth>
  //       <AreaOfInterests />
  //     </RequireAuth>
  //   ),
  // },
  // {
  //   path: "/coupons",
  //   element: (
  //     <RequireAuth>
  //       <CouponsPage />
  //     </RequireAuth>
  //   ),
  // },
]);

export default router;
